import { motion } from 'framer-motion'
import { cn } from '~/shared/lib/cn'
import { IconButton, Text } from '~/shared/ui'
import type { DataExtractionMode } from '../../types'

export function FieldLayout({
  children,
  mode,
  required,
  active,
  fieldKey,
  fullRowField,
  toggleFieldActive,
}: {
  children: React.ReactNode
  mode: DataExtractionMode
  required: boolean
  active: boolean
  fieldKey: string
  fullRowField?: boolean
  toggleFieldActive: (fieldName: string) => void
}) {
  if (mode === 'view') {
    if (!active) {
      return null
    }
    return (
      <motion.div
        layout
        layoutId={`field-${fieldKey}`}
        className={cn({
          'col-span-2': fullRowField,
        })}
      >
        {children}
      </motion.div>
    )
  }

  return (
    <motion.div
      layout
      className="pointer-events-auto! grid grid-cols-[minmax(0,1fr)_42px_minmax(0,1fr)] items-center gap-4 opacity-100!"
    >
      <motion.div
        layout
        className="h-full min-w-0"
      >
        {active ? (
          <motion.div
            layout
            layoutId={`field-${fieldKey}`}
          >
            {children}
          </motion.div>
        ) : (
          <div className="h-full pt-2">
            <div className="bg-content-lowest-emphasis border-divider h-full rounded-sm border border-dashed"></div>
          </div>
        )}
      </motion.div>
      <motion.div
        layout
        className="pt-2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ opacity: { delay: 0.3 }, layout: { duration: 0 } }}
      >
        <IconButton
          className={cn({
            'text-text-link': !required,
          })}
          size="small"
          container="medium"
          onClick={() => {
            toggleFieldActive(fieldKey)
          }}
          materialIcon={active ? 'arrow_forward' : 'arrow_back'}
          disabled={required}
        />
      </motion.div>
      <motion.div
        layout
        className="h-full min-w-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ opacity: { delay: 0.3 }, layout: { duration: 0 } }}
      >
        {active ? (
          <div className="h-full pt-2">
            <div className="bg-content-lowest-emphasis border-divider flex h-full items-center justify-center rounded-sm border border-dashed">
              {required ? (
                <Text
                  className="text-text-disabled"
                  appearance="BODY2"
                >
                  Required for Validation
                </Text>
              ) : null}
            </div>
          </div>
        ) : (
          <motion.div
            layout
            layoutId={`field-${fieldKey}`}
          >
            {children}
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  )
}
